<template>
  <div class="import-tool">
    <Modal v-model="visible" title="批量导入保单" :closable="false" :mask-closable="false" width="530" :footer-hide="true" 
      class="my-modal top import-tool-modal2">
      <div class="top-btn" v-if="progress>0&&progress<100" @click="small">缩小</div>
      <Icon type="md-close top-btn" v-else @click="close(curData, true)"/>
      <div class="ivu-modal-footer">
        <div class="text1">导入进度</div>
        <div class="btn-box">
          <tooltip :txtInfo="curData.fileName" v-if="curData.fileName&&curData.fileName.length>20"></tooltip>
          <span v-else>{{curData.fileName}}</span>
          <Upload ref="upload" 
            :show-upload-list="false"
            class="upload-btn"
            :format="fileFormat"
            :max-size="2048"
            :before-upload="handleFormatError"
            accept=".xls,.xlsx"
            action="/"
          >
            <Button type="primary" ghost v-if="!curData.fileName">上传Excel</Button>
            <Button type="primary" ghost v-if="curData.fileName&&progress==0&&!uploadLoading">重传Excel</Button>
            <Button type="primary" v-if="curData.fileName&&progress==100">继续上传Excel</Button>
          </Upload> 
          <Button type="primary" @click="startUpload" v-if="curData.fileName && progress != 100" :loading="uploadLoading">确定导入</Button>
        </div>
      </div>
      <Progress :percent="progress" status="active" />
      <div class="progress-text" :class="{'show':curData.total}">
        <span>已导入{{curData.fail+curData.success}}/{{curData.total}}条</span>
        <span>成功{{curData.success}}条</span>
        <span>失败{{curData.fail}}条</span>
      </div>
      <div class="ivu-modal-footer">
        <div class="btn-box">
          <Button type="primary" @click="download(1)" ghost>下载导入模板</Button>
        </div>
        <div class="btn-box">
          <Button type="primary" @click="download(2)" v-if="curData.success">导出成功文件</Button>
          <Button type="primary" @click="download(3)" v-if="curData.fail">导出失败文件</Button>
        </div>
      </div>
    </Modal>

    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>  
  </div>
</template>
<script>
import confirmModal from '@/components/commons/confirmModal'
import tooltip from '@/components/commons/tooltip'
export default {
  props:{
    code: {
      default: '',
      type: String
    },
  },
  components:{
    confirmModal,
    tooltip,
  },
  data() {
    return {
      fileFormat:['xls','xlsx'],
      uploadLoading:false,
      visible:false,
      visibleSmall:false,
      timerOpen:false,//当前是否在轮询
      data:{},
      file:{},
      params:{},
      progress:0,
      curData:{},
      list:[],//进行中任务列表
    };
  },
  activated(){
    console.log("activated")
    this.visibleSmall = true;
    this.startTask();
  },
  deactivated(){
    this.visible = false;
    this.visibleSmall = false;
  },
  methods: {
    open(params){
      this.params = params;
      this.curData = {};
      this.file = {};
      this.progress = 0;
      this.visible = true;
      this.uploadLoading = false;
    },
    // 关闭弹窗 isBig 是否是关闭的大弹窗
    close(item, isBig) {
      // 如果文件正在上传，关闭弹窗取消上传
      if(this.uploadLoading){
        this.$units.cancelhttpRequest();
      }
      if (item.fail) {
        this.$refs.confirmModal.open({
          title: "提示",
          content: "关闭前是否导出失败文件？",
        }).then(() => {
          this.download(3, item.batchNo).then(() => {
            if(!this.file.loading){
              this.closeAjax(item.batchNo)
            }
            isBig && this.small();
          });
        }).catch(() => {
          isBig && this.small();
          item.batchNo && !this.file.loading && this.closeAjax(item.batchNo);
        });
      } else {
        isBig && this.small();
        item.batchNo && !this.file.loading && this.closeAjax(item.batchNo);
      }
    },
    // 缩小
    small() {
      this.visible = false;
      this.params.batchNo = "";
    },
    // 放大
    big(item) {
      this.visible = true;
      this.curData = item;
      this.progress = item.progress;
      this.params.batchNo = item.batchNo;
    },
    // 完成后删除任务
    closeAjax(batchNo) {
      this.$http({
        url: "/buz/importTask/close",
        type: "GET",
        data: {
          code: this.code,
          batchNo: batchNo,
        }
      }).then(() => {
        if (!this.timerOpen) {
          this.startTask();
        }
      })
    },
    // 1 模板 2成功 3失败
    download(type=1,batchNo=this.curData.batchNo) {
      let url = this.params.template;
      if(type==2){//成功
        url = "/buz/importTask/successResult";
      }else if(type==3){//失败
        url = "/buz/importTask/errorResult";
      }
      return this.$http({
        url: url,
        type: 'GET',
        forced: true,
        responseType: "blob",
        All: true,
        data:type==1?{code: this.code}:{
          code:this.code,
          batchNo:batchNo,
        }
      }).then(res=>{
        if (res.headers['content-type'].includes('json')) {
          const { data } = res
          const reader = new FileReader()
          reader.onload = () => {
            const { result } = reader
            const errorInfos = JSON.parse(result)
            const { msg } = errorInfos
            this.$notice.error(msg)
          }
          reader.onerror = err => {
            reject(err)
          }
          reader.readAsText(data)
          return;
        }
        this.$units.daochu(res);
      })
    },

    // 文件文件格式验证失败时的钩子，返回字段为 file, fileList
    handleFormatError(file){
      const format = file.name.split("\.")[1];
      if(!this.fileFormat.includes(format)){
        this.$notice.msg("请上传"+this.fileFormat.join(",")+"格式的文件")
        return false;
      }
      this.curData = {
        fileName:file.name.split("\.")[0]
      }
      this.file = file;
      this.progress = 0;
      this.params.batchNo ='';
      return false;
    },
    // 开始上传
    startUpload(){
      if(this.file.loading){
        return;
      }
      this.file.loading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      const close = this.$notice.loading("文件解析校验中");
      this.uploadLoading = true;
      this.$http({
        url: this.params.upload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData
      }).then(res=>{
        close();
        this.params.batchNo = res.data;
        this.file.loading = false;
        this.params.batchNo = res.data;
        if(!this.timerOpen){//当前如果没轮询启动轮询
          this.startTask();
        }
      }).catch((e)=>{
        console.log(e);
        close();
        this.file.loading = false;
      })
    },
    // 开始轮询进度
    startTask(batchNo = this.params.batchNo){
      this.$http({
        url: "/buz/importTask/progress",
        type: "get",
        data:{
          code: this.code,
          batchNo: batchNo,
        }
      }).then((res) => {
        if(!this.params.batchNo && !this.visible){
          this.curData = {};
        }
        let hasWait = false;
        res.data.forEach(item=>{
          item.progress = ((item.fail+item.success)/item.total*100).toFixed(0)*1;
          if(this.params.batchNo==item.batchNo){
            this.curData = item;
            this.progress = item.progress;
          }
          if(item.progress!=100){
            hasWait = true;
          }
        })
        this.list = res.data;
        if(!this.list.length||!hasWait){
          this.timerOpen = false;
          return;
        }
        this.timerOpen = true;
        if(this.visibleSmall||this.visible){
          window.setTimeout(()=>{
            this.startTask();
          },1000)
        }
        this.uploadLoading = false;
      }).catch(()=>{
        this.timerOpen = true;
        this.uploadLoading = false;
        window.setTimeout(()=>{
          this.startTask();
        },1000)
      })
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./importModal.scss";
</style>
